'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import Loadable from 'UIComponents/decorators/Loadable';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
export default (loader => {
  return Loadable({
    loader,

    LoadingComponent({
      pastDelay
    }) {
      return pastDelay ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true
      }) : null;
    }

  });
});